
(function () {
    'use strict';
    angular
            .module('caloappApp')
            .controller('CaloriesController', CaloriesController);
    CaloriesController.$inject = ['$scope', 'CaloriesModalService', 'paginationConstants', 'pagingParams',
        'AlertService', 'ParseLinks', 'CaloriesService', '$stateParams', '$state', 'Principal', 'User',
        '$filter'];
    function CaloriesController($scope, CaloriesModalService, paginationConstants, pagingParams,
            AlertService, ParseLinks, CaloriesService, $stateParams, $state, Principal, User,
            $filter) {
        var vm = this;
        vm.userLogin = $stateParams.username;

        // the number of calories/day specified by the user
        vm.dailyCaloriesLimit = null;

        // the error message to display when something goes wrong with the filter
        vm.filterErrorMessageToDisplay = null;

        // boolean indicating whether the list of meals information is loading
        vm.isListMealsInformationLoading = false;

        // this method is called to init the page
        vm.init = init;

        // list of keys to get the different meals information by date.
        // Each element contain the number of meals information having the same date and the
        // index, within the list vm.mealInformationsSimpleList, of the first element having that date
        vm.listInformationByDate = [];

        // simple list of meals information
        vm.mealInformationsSimpleList = [];

        // this list will contain for each day the total calories added by the user
        vm.listCaloriesPerDay = [];

        // this method clears the filter and reload the page without filters
        vm.clearFilter = clearFilter;

        // pagination information
        vm.page = 1;
        vm.totalItems = null;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.links = null;
        vm.transition = transition;

        // this method is called to loead meals information matching a specific page
        // => when the user changes a page
        vm.loadPage = loadPage;
        // this method reload the current page
        vm.loadAll = loadAll;
        // this method opens the meal modal whether for creation or edition
        vm.openMealModal = CaloriesModalService.open;

        // given the date in the parameter this method checks whether the user has exceeded the calories
        // limit or not. It returns true if the limit is exceeded
        vm.checkLimit = checkLimit;

        // method called to edit a meal information line
        vm.editMealInformation = editMealInformation;

        // this method is called to filter calories by date and time
        vm.loadMealsInformationByFilter = loadMealsInformationByFilter;

        // this boolean indicates whether the filter is processing or not
        vm.isFilterProcessing = false;

        // this method transforms a time represented in ms to a valid date
        vm.getTime = getTime;

        // the filter information that will be used by the filter query
        vm.filterInformationForQuery = {
            beginDate: pagingParams.fromDate,
            endDate: pagingParams.toDate,
            beginTime: pagingParams.fromTime,
            endTime: pagingParams.toTime
        };

        // the filter information that would be manipulated within the screen
        vm.filterInformationForScreen = {
            beginDate: pagingParams.fromDate ? new Date(pagingParams.fromDate) : null,
            endDate: pagingParams.toDate ? new Date(pagingParams.toDate) : null,
            beginTime: pagingParams.fromTime ? vm.getTime(pagingParams.fromTime) : null,
            endTime: pagingParams.toTime ? vm.getTime(pagingParams.toTime) : null
        };

        function getTime(aTimeInMs) {
            // get the number of hours
            var lNbHours = parseInt(aTimeInMs / (3600 * 60));
            var lNbMinutes = parseInt((aTimeInMs % (3600 * 60)) / 3600);

            // the date to return
            var lDate = new Date();
            lDate.setHours(lNbHours);
            lDate.setMinutes(lNbMinutes);
            lDate.setSeconds(0);
            lDate.setMilliseconds(0);

            return lDate;
        }



        vm.init();

        function init() {

            // decide whether the user is displaying his own information or if it is an administrator
            // who is doing it
            Principal.identity().then(function (account) {

                vm.isSameUser = (account.login === vm.userLogin);

            });

            // get the displayed user's daily calories limit
            User.get(
                    {login: vm.userLogin},
                    function (result) {
                        vm.dailyCaloriesLimit = result.calories;
                    });
        }

        function editMealInformation(aMealInformation) {
            vm.openMealModal(aMealInformation);
        }


        // we load the meals on page initialization
        vm.loadAll();


        function loadAll() {

            vm.isListMealsInformationLoading = true;

            CaloriesService.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                userLogin: vm.userLogin,
                fromDate: vm.filterInformationForQuery.beginDate ? vm.filterInformationForQuery.beginDate : null,
                toDate: vm.filterInformationForQuery.endDate ? vm.filterInformationForQuery.endDate : null,
                fromTime: vm.filterInformationForQuery.beginTime ? vm.filterInformationForQuery.beginTime : null,
                toTime: vm.filterInformationForQuery.endTime ? vm.filterInformationForQuery.endTime : null
            }, onSuccess, onError);
        }

        function clearFilter() {
            // we perform this action only if the user hasn't already initiated a loading action
            if (!vm.isListMealsInformationLoading) {
                vm.page = 1;

                $state.transitionTo($state.$current, {
                    page: vm.page,
                    sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                    username: vm.userLogin,
                    fromDate: null,
                    toDate: null,
                    fromTime: null,
                    toTime: null
                });
            }

        }

        function loadMealsInformationByFilter() {

            vm.filterErrorMessageToDisplay = null;


            if (!vm.isFilterProcessing) {
                vm.isFilterProcessing = true;

                // we transform the different dates and times into ms

                // Begin date
                var lBeginDate = new Date(vm.filterInformationForScreen.beginDate);
                lBeginDate.setHours(0);
                lBeginDate.setMinutes(0);

                lBeginDate = lBeginDate.getTime();

                // End date
                var lEndDate = new Date(vm.filterInformationForScreen.endDate);
                lEndDate.setHours(23);
                lEndDate.setMinutes(59);

                lEndDate = lEndDate.getTime();

                // Begin time
                var lBeginTime = new Date(vm.filterInformationForScreen.beginTime);
                var lNbHours = lBeginTime.getHours();
                var lNbMinutes = lBeginTime.getMinutes();

                lBeginTime = (((lNbHours * 60) + lNbMinutes) * 3600) - 10;

                // End time
                var lEndTime = new Date(vm.filterInformationForScreen.endTime);
                lNbHours = lEndTime.getHours();
                lNbMinutes = lEndTime.getMinutes();

                lEndTime = (((lNbHours * 60) + lNbMinutes) * 3600) + 10;

                if ((lBeginDate >= lEndDate) || (lEndTime <= lBeginTime)) {
                    vm.filterErrorMessageToDisplay = $filter('translate')('calories.filter.errorMessage');
                    vm.isFilterProcessing = false;
                    return;
                }

                vm.page = 1;

                $state.transitionTo($state.$current, {
                    page: vm.page,
                    sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                    username: vm.userLogin,
                    fromDate: Number(lBeginDate),
                    toDate: Number(lEndDate),
                    fromTime: Number(lBeginTime),
                    toTime: Number(lEndTime)
                });
            }
        }

        function checkLimit(aDate) {
            if (vm.listCaloriesPerDay[aDate]) {
                return (vm.listCaloriesPerDay[aDate] > vm.dailyCaloriesLimit);
            }
            return false;
        }

        function onSuccess(data, headers) {

            vm.isFilterProcessing = false;

            for (var i in data) {

                if (data[i].userLogin) {

                    var lMealInformation = data[i];

                    //get the number of hours
                    var lNbHours = parseInt(lMealInformation.time / (3600 * 60)) + '';

                    if (lNbHours.length === 1) {
                        lNbHours = '0' + lNbHours;
                    }
                    var lNbMinutes = parseInt((lMealInformation.time % (3600 * 60)) / 3600) + '';

                    if (lNbMinutes.length === 1) {
                        lNbMinutes = '0' + lNbMinutes;
                    }

                    lMealInformation.timeToDisplay = lNbHours + ':' + lNbMinutes;

                    if (vm.listInformationByDate[lMealInformation.date]) {
                        vm.listInformationByDate[lMealInformation.date].nbElts++;
                    } else {
                        var lInformationByDate = {
                            nbElts: 1,
                            index: i
                        };
                        vm.listInformationByDate[lMealInformation.date] = lInformationByDate;
                    }



                    if (vm.listCaloriesPerDay[lMealInformation.date]) {
                        vm.listCaloriesPerDay[lMealInformation.date] += lMealInformation.calories;
                    } else {
                        vm.listCaloriesPerDay[lMealInformation.date] = lMealInformation.calories;
                    }

                    vm.mealInformationsSimpleList.push(lMealInformation);

                }
            }

            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;

            vm.isListMealsInformationLoading = false;

        }

        function onError(error) {
            vm.isListMealsInformationLoading = false;
            vm.isFilterProcessing = false;
            AlertService.error(error.data.message);
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                username: vm.userLogin,
                fromDate: vm.filterInformationForQuery.beginDate ? vm.filterInformationForQuery.beginDate : null,
                toDate: vm.filterInformationForQuery.endDate ? vm.filterInformationForQuery.endDate : null,
                fromTime: vm.filterInformationForQuery.beginTime ? vm.filterInformationForQuery.beginTime : null,
                toTime: vm.filterInformationForQuery.endTime ? vm.filterInformationForQuery.endTime : null
            });
        }

    }
})();
